import ApiClient from './ApiClient';

export default class AgencyApi extends ApiClient {
  /**
   * Загрузить список агенств
   * @param dealType
   * @param realtyType
   * @param filter
   * @returns {*}
   */
  fetchAgencies (dealType, realtyType, filter) {
    return this.get(`${this.prefix}${dealType}/${realtyType}/agencies`, filter);
  }

}



// WEBPACK FOOTER //
// ./src/api/Agency.js